import { useEffect, useState } from "react"
import { usePostHog } from "posthog-js/react"
import axios from "axios"

// Utility function to check API health that works in both client and server
// export const checkApiHealth = async () => {
//     try {
//         await axios.get(`${process.env.NEXT_PUBLIC_API_URL}health`)
//         return true
//     } catch (err) {
//         return false
//     }
// }

export const useMaintenanceMode = (initialMaintenanceState = false) => {
    const [isInMaintenance, setIsInMaintenance] = useState(
        initialMaintenanceState
    )
    const posthog = usePostHog()

    useEffect(() => {
        const checkMaintenanceStatus = async () => {
            try {
                // Check if maintenance mode is enabled via PostHog feature flag
                const isMaintenance =
                    posthog?.isFeatureEnabled("maintenance-mode") ?? false

                if (isMaintenance) {
                    setIsInMaintenance(true)
                    return
                }

                // Check API health
                // const isHealthy = await checkApiHealth()
                // setIsInMaintenance(!isHealthy)
            } catch {
                // If any error occurs during check, set maintenance mode
                setIsInMaintenance(true)
            }
        }

        // Only run health checks in the browser
        if (typeof window !== "undefined") {
            checkMaintenanceStatus()
            // Set up interval to check status periodically
            const interval = setInterval(checkMaintenanceStatus, 60000) // Check every minute
            return () => clearInterval(interval)
        }
    }, [posthog])

    return isInMaintenance
}
